const Images = {
    // Skills
    frontend : require('./Images/Skills/htmlcssjs.png'),
    react : require('./Images/Skills/react.png'),
    reactNative : require('./Images/Skills/react_native.png'),
    python : require('./Images/Skills/python.png'),
    mysql : require('./Images/Skills/mysql.png'),
    Certification : require('./Images/Skills/Certification.png'),
    figma : require('./Images/Skills/figma.png'),
    notion : require('./Images/Skills/notion.png'),
    slack : require('./Images/Skills/slack.png'),
    space : require('./Images/Skills/space.png'),
    github : require('./Images/Skills/github.png'),
    aws : require('./Images/Skills/aws.png'),
    aws_developer : require('./Images/Skills/aws_developer.png'),

    // WeMap
    WeMapStart : require('./Images/WeMap/WeMap_Start.png'),
    WeMapLogin : require('./Images/WeMap/WeMap_Login.png'),
    WeMapSignup : require('./Images/WeMap/WeMap_Signup.png'),
    WeMapHome : require('./Images/WeMap/WeMap_Home.png'),
    WeMapSidebar : require('./Images/WeMap/WeMap_Sidebar.png'),
    WeMapMypage : require('./Images/WeMap/WeMap_Mypage.png'),
    WeMapAlarm : require('./Images/WeMap/WeMap_Alarm.png'),
    WeMapNotice : require('./Images/WeMap/WeMap_Notice.png'),
    WeMapClickIcon : require('./Images/WeMap/WeMap_ClickIcon.png'),
    WeMapFindload : require('./Images/WeMap/WeMap_Findload.png'),

    // Buzzer Beater
    BBStart : require('./Images/BuzzerBeater/BuzzerBeater_Start.png'),
    BBLogin : require('./Images/BuzzerBeater/BuzzerBeater_Login.png'),
    BBSignup : require('./Images/BuzzerBeater/BuzzerBeater_Signup.png'),
    BBHome : require('./Images/BuzzerBeater/BuzzerBeater_Home.png'),
    BBCreate : require('./Images/BuzzerBeater/BuzzerBeater_Create.png'),
    BBList : require('./Images/BuzzerBeater/BuzzerBeater_List.png'),
    BBMerc : require('./Images/BuzzerBeater/BuzzerBeater_Merc.png'),
    BBMypage : require('./Images/BuzzerBeater/BuzzerBeater_Mypage.png'),
    BBNickname : require('./Images/BuzzerBeater/BuzzerBeater_Change1.png'),
    BBPassword : require('./Images/BuzzerBeater/BuzzerBeater_Change2.png'),
    BBPhysical : require('./Images/BuzzerBeater/BuzzerBeater_Change3.png'),
    BBCheck : require('./Images/BuzzerBeater/BuzzerBeater_Check.png'),
    BBPosition : require('./Images/BuzzerBeater/BuzzerBeater_Change4.png'),
    BBNotice : require('./Images/BuzzerBeater/BuzzerBeater_Notice.png'),
    BBClickMerc : require('./Images/BuzzerBeater/BuzzerBeater_Clickmerc.png'),
    BBClickList : require('./Images/BuzzerBeater/BuzzerBeater_Clicklist.png'),

    // Portfolio
    PortfolioID : require('./Images/Portfolio/Portfolio_ID.png'),
    PortfolioSkill : require('./Images/Portfolio/Portfolio_Skills.png'),
    PortfolioProject : require('./Images/Portfolio/Portfolio_Project1.png'),
    PortfolioArchitect : require('./Images/Portfolio/Portfolio_Project2.png'),
    PortfolioActivity : require('./Images/Portfolio/Portfolio_Activity.png'),

    BirdStart : require('./Images/Bigbird/start_screen.png'),
    BirdClick : require('./Images/Bigbird/click_screen.png'),
    BirdSelect : require('./Images/Bigbird/select_screen.png'),
    BirdObject : require('./Images/Bigbird/object_screen.png'),

    // etc
    profile : require('./Images/Profile_Image.JPG'),
    github_button : require('./Images/github-mark.png'),
    plus : require('./Images/free-icon-zoom-117453.png'),
    WeMapArchitecture : require('./Images/WeMap.png'),
    BBArchitecture : require('./Images/BuzzerBeater.png'),
};

export default Images;